<template>
    <div class="row">
        <div class="col-lg-6">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Precios por tipo vehículo
                </div>
                <div class="panel-body">
                    <div class="col-lg-4">
                        <div class="">
                            <h4>Hasta 3 pasajeros</h4>
                        </div>
                        <div class="form-group">
                            <label>Tarifa por km (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass3.perKmRate"/>
                        </div>
                        <div class="form-group">
                            <label>Flat x viaje (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass3.flatRate"/>
                        </div>
                        <div class="form-group">
                            <label>Precio Aeropuerto - Hotel (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass3.airportToHotel"/>
                        </div>
                        <div class="form-group">
                            <label>Precio Hotel - Aeropuerto (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass3.hotelToAirport"/>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="">
                            <h4>Hasta 4 pasajeros</h4>
                        </div>
                        <div class="form-group">
                            <label>Tarifa por km (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass4.perKmRate"/>
                        </div>
                        <div class="form-group">
                            <label>Flat x viaje (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass4.flatRate"/>
                        </div>
                        <div class="form-group">
                            <label>Precio Aeropuerto - Hotel (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass4.airportToHotel"/>
                        </div>
                        <div class="form-group">
                            <label>Precio Hotel - Aeropuerto (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass4.hotelToAirport"/>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="">
                            <h4>Hasta 8 pasajeros</h4>
                        </div>
                        <div class="form-group">
                            <label>Tarifa por km (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass8.perKmRate"/>
                        </div>
                        <div class="form-group">
                            <label>Flat x viaje (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass8.flatRate"/>
                        </div>
                        <div class="form-group">
                            <label>Precio Aeropuerto - Hotel (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass8.airportToHotel"/>
                        </div>
                        <div class="form-group">
                            <label>Precio Hotel - Aeropuerto (USD) *</label>
                            <custom-input tipo="text" :field="$v.form.pass8.hotelToAirport"/>
                        </div>
                    </div>
                    <div class="text-right">
                        <a class="btn btn-primary" @click="save" :disabled="loading">Guardar</a>
                    </div>


                </div>
            </div>

        </div>
        <div class="col-lg-6">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Alta demanda
                </div>
                <div class="panel-body">
                    <div class="row" v-for="(v, index) in $v.form.rushPeriods.$each.$iter">
                        <div class="col-md-4 form-group">
                            <label>Hora de inicio *</label>
                            <custom-input tipo="mask" :field="v.startHour" mask="##:##" placeholder="hh:mm"/>
                        </div>
                        <div class="col-md-4 form-group">
                            <label>Hora de fin *</label>
                            <custom-input tipo="mask" :field="v.endHour" mask="##:##" placeholder="hh:mm"/>
                        </div>
                        <div class="col-md-3 form-group">
                            <label>% Aumento *</label>
                            <custom-input tipo="text" :field="v.increase"/>
                        </div>
                        <div class="col-md-1 form-group">
                            <button style="margin-top:26px;" class="btn btn-default btn-circle"
                                    @click="removeRushPeriod(index)" type="button"><i
                                class="fa fa-remove"></i>
                            </button>
                        </div>
                    </div>
                    <a class="btn btn-primary btn-outline" @click="addRushPeriod">
                        <i class="fa fa-plus"></i> Agregar</a>

                    <a class="btn btn-primary float-right" @click="save" :disabled="loading">Guardar</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {DASHBOARD} from "../../router/routes";
import CustomInput from '../common/CustomInput.vue'
import {decimal, required} from 'vuelidate/lib/validators'
import firebase from '../../services/firebase'
import Alert from "../../util/alert";
import {hour, hourGreaterThan} from '../../directives/customValidations'

export default {
    components: {CustomInput},
    props: {
        hotelCode: {
            type: String,
            required: true
        }
    },
    data: () => ({
        dashboardRoute: DASHBOARD.route,
        loading: false,
        form: {
            pass3: {
                perKmRate: null,
                flatRate: null,
                airportToHotel: null,
                hotelToAirport: null,
            },
            pass4: {
                perKmRate: null,
                flatRate: null,
                airportToHotel: null,
                hotelToAirport: null,
            },
            pass8: {
                perKmRate: null,
                flatRate: null,
                airportToHotel: null,
                hotelToAirport: null,
            },
            rushPeriods: [],

        },
    }),
    validations: {
        form: {
            pass3: {
                perKmRate: {required, decimal},
                flatRate: {required, decimal},
                airportToHotel: {required, decimal},
                hotelToAirport: {required, decimal},
            },
            pass4: {
                perKmRate: {required, decimal},
                flatRate: {required, decimal},
                airportToHotel: {required, decimal},
                hotelToAirport: {required, decimal},
            },
            pass8: {
                perKmRate: {required, decimal},
                flatRate: {required, decimal},
                airportToHotel: {required, decimal},
                hotelToAirport: {required, decimal},
            },
            rushPeriods: {
                $each: {
                    startHour: {required, hour},
                    endHour: {required, hour, hourGreaterThan: hourGreaterThan('startHour')},
                    increase: {required, decimal}
                }
            }
        }
    },
    methods: {
        load(data) {
            this.populatePricesByType(data.passengersConf['A'], 'pass3');
            this.populatePricesByType(data.passengersConf['B'], 'pass4');
            this.populatePricesByType(data.passengersConf['C'], 'pass8');

            const sortedRushPeriods = [...Object.keys(data.rushPeriods)].sort();
            this.form.rushPeriods = [];
            sortedRushPeriods.forEach(it => {
                const increase = data.rushPeriods[it];
                const startHour = it.substring(0, 2).concat(":").concat(it.substring(2, 4));
                const endHour = it.substring(4, 6).concat(":").concat(it.substring(6, 8));
                this.form.rushPeriods.push({startHour, endHour, increase: (increase * 100).toFixed(2)})
            });
        },
        populatePricesByType(data, type) {
            if (!data)
                return;
            const {perKmRate, flatRate, hotelToAirport, airportToHotel} = data;
            this.form[type].perKmRate = perKmRate ? perKmRate.toFixed(2) : null;
            this.form[type].flatRate = flatRate ? flatRate.toFixed(2) : null;
            this.form[type].hotelToAirport = hotelToAirport ? hotelToAirport.toFixed(2) : null;
            this.form[type].airportToHotel = airportToHotel ? airportToHotel.toFixed(2) : null;
        },
        getPricesByType(type) {
            const form = {...this.form};
            return {
                perKmRate: Number(form[type].perKmRate),
                flatRate: Number(form[type].flatRate),
                airportToHotel: Number(form[type].airportToHotel),
                hotelToAirport: Number(form[type].hotelToAirport)
            };
        },
        async save() {
            this.$v.$touch();
            if (this.$v.$error) return;

            const data = {passengersConf: {}, rushPeriods: {}};
            const form = {...this.form};
            data.passengersConf['A'] = this.getPricesByType('pass3');
            data.passengersConf['B'] = this.getPricesByType('pass4');
            data.passengersConf['C'] = this.getPricesByType('pass8');

            form.rushPeriods.forEach((it) => {
                const key = it.startHour.replace(":", "").concat(it.endHour.replace(":", ""));
                data.rushPeriods[key] = Number(it.increase) / 100;
            });

            try {
                this.loading = true;
                const pricingRef = firebase.getFirestore().collection("settings").doc(this.hotelCode.toLowerCase());
                await pricingRef.set(data);
                this.load(data);
                Alert.mensajeExito("Se actualizó la información correctamente");
            } catch (error) {
                console.error("Error writing document: ", error);
                Alert.mensajeError("No se puedo actualizar configuración de precios.");
            } finally {
                this.loading = false;
            }
        },
        addRushPeriod() {
            if (!this.form.rushPeriods)
                this.form.rushPeriods = [];
            this.form.rushPeriods.push({startHour: null, endHour: null, increase: null})
        },
        removeRushPeriod(index) {
            this.form.rushPeriods.splice(index, 1);
        },
    },
    async mounted() {
        const self = this;
        try {
            if (!this.hotelCode)
                return;
            const pricingRef = firebase.getFirestore().collection("settings").doc(this.hotelCode.toLowerCase());
            const doc = await pricingRef.get();
            if (doc.exists) {
                this.load(doc.data())
            } else {
                console.error("No se encontro configuracion de precios");
            }
        } catch (error) {
            console.error("Error al obtener configuracion de precios:", error);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/hotel/HotelPricing.vue